var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66536 30H9.9987V36.8017L18.5004 30H26.6654C28.5037 30 29.9987 28.505 29.9987 26.6667V13.3333C29.9987 11.495 28.5037 10 26.6654 10H6.66536C4.82703 10 3.33203 11.495 3.33203 13.3333V26.6667C3.33203 28.505 4.82703 30 6.66536 30Z",
    fill: "#403531"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 3.33334H13.3333C11.495 3.33334 10 4.82834 10 6.66667H30C31.8383 6.66667 33.3333 8.16167 33.3333 10V23.3333C35.1717 23.3333 36.6667 21.8383 36.6667 20V6.66667C36.6667 4.82834 35.1717 3.33334 33.3333 3.33334Z",
    fill: "#403531"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.30158578f6c927bf7cdcee43a7a7a8ee.svg";
export { ForwardRef as ReactComponent };